
//  Gestione CaboloMeetings

export interface IRecordingMeeting {
    id: number;
    meetingId: boolean;
    basename: string;
    duration: number;
    startDate: string;
    endDate: string;
    size: number;
    title: string;
    guid: string;
    statusDownloadZip: string 
}
 
export interface IRecordingMeetingPageDto {

    recordings: IRecordingMeeting[];
    canDownloadZipTranscription : boolean
    canDownloadDocTranscription : boolean
    canDownloadAudioVideoTranscription : boolean
    canManageTranscriptions : boolean
}


export interface ICaboloMeetingInfo {
    caboloId: number;
    hasEnabledRegistrationCabolo: number;
}

// CABOLO STATUS

export interface CaboloStatus {
    status: string;
  
}
// RECORDIG STATUS

export interface RecStatus { 

    audioLength: number;
    recordingId: number;
    sttTranscriptionlenght: number;
    isRecordingMeeting: boolean;
    meetingId: number;
}



// Audio DEVICES

export interface AudioDevice {
    id: number;
    busy: boolean;
    name: string;
    isDefault: boolean;
    isVisible: boolean;
   
   }

//  MODELS TRANSCRIPTION

export interface TranscriptionModel {
    id: number;
    name: string;
    lang: string;
    sipCompatible: boolean;
    isDefault: boolean;
    isVisible: boolean;
}   


// LANGUAGES PAIRS

export interface LanguagePair {
    sourceLanguage: string;
    sourceLanguageId: string;
    targetLanguage: string;
    targetLanguageId: string;
    isDefault: boolean;
    isVisible: boolean;
}



// Cabolo Form Values

export interface ICaboloRecordingSettings {
    meetingId: number;
    caboloId: number;
    audioDeviceId: number;
    transcriptionModelId: number;
    languagePairSelected: string[];
   audioDevices: AudioDevice[];
    transcriptionModels: TranscriptionModel[];
    languagePairs: LanguagePair[];
}

export interface ICaboloRecordingForm{

    caboloId: number;
    meetingId: number;
    title: string;
    audioDeviceId: number;
    transcriptionModelId: number;
    languageTranscriptionSelected: string[];
    
}


export class IcaboloRecodingFormValues implements ICaboloRecordingForm {
 
    constructor(init?: ICaboloRecordingForm) {
      Object.assign(this, init);
    }
    languageTranscriptionSelected:string[]=[];
    title = "";
    meetingId=0;
    caboloId=0;
    audioDeviceId=0;
    transcriptionModelId=0;
    
  }
  

export enum DownloadRecordingZipSTatus{
  
    STATE_HOLD_ON = "hold_on",
    STATE_IN_PROGRESS = "progress",
    STATE_READY = "ready",
    STATE_ERROR = "error",
    STATE_DELETED_BY_USER = "deleted_by_user"
}

export enum DownloadRecordingTypes{
  
    Docx = "docx",
    Zip = "zip",
    Audio = "mp3",

}

export enum CaboloErrorEnum {
    ErrorCaboloNotFound = "ErrorCaboloNotFound",
    ErrorCaboloBadRequest = "ErrorCaboloBadRequest",
    ErrorCaboloInternalServerError = "ErrorCaboloInternalServerError",
    ErrorCaboloUnauthorized = "ErrorCaboloUnauthorized",
    ErrorCaboloForbidden = "ErrorCaboloForbidden",
    CaboloTimeout = "CaboloTimeout",
    CaboloFailedConnection = "CaboloFailedConnection",
    CaboloErrorGeneric = "CaboloErrorGeneric",
  }


  export enum CaboloStatusEnum {
    STATE_ERROR_CONNECTION = "STATE_ERROR_CONNECTION",
    STATE_READY = "STATE_READY",
    STATE_PAUSED = "STATE_PAUSED",
    STATE_PLAYING = "STATE_PLAYING",
    STATE_CHANGE_READY_TO_PLAY = "STATE_CHANGE_READY_TO_PLAY",
    STATE_CHANGE_PLAY_TO_PAUSE = "STATE_CHANGE_PLAY_TO_PAUSE",
    STATE_CHANGE_PLAY_TO_READY = "STATE_CHANGE_PLAY_TO_READY",
    STATE_CHANGE_PAUSE_TO_PLAY = "STATE_CHANGE_PAUSE_TO_PLAY",
    STATE_CHANGE_PAUSE_TO_READY = "STATE_CHANGE_PAUSE_TO_READY",
    STATE_LOCKED = "STATE_LOCKED",
    STATE_INTERRUPTED = "STATE_INTERRUPTED",
    STATE_MOVE_INTERRUPTED = "STATE_MOVE_INTERRUPTED",
    STATE_WAITING = "STATE_WAITING",
    STATE_CHANGE_PLAY_TO_WAITING = "STATE_CHANGE_PLAY_TO_WAITING",
    STATE_CHANGE_PAUSE_TO_WAITING = "STATE_CHANGE_PAUSE_TO_WAITING",
    STATE_LICENSE_EXPIRED = "STATE_LICENSE_EXPIRED",
    STATE_LOADING = "STATE_LOADING"
  }
